import { render, staticRenderFns } from "./core-action.vue?vue&type=template&id=b015c822"
import script from "./core-action.vue?vue&type=script&lang=js"
export * from "./core-action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports